
import { db, serverTimestamp } from "../../../../firebaseClient";
import type { SignRequest } from "../../../types/signRequest";

const COLLECTION = "sign_requests";

export async function createSignRequest(data: Omit<SignRequest, "id">): Promise<string> {
  const docRef = await db.collection(COLLECTION).add(data);
  return docRef.id;
}

export async function updateSignRequest(id: string, data: Partial<SignRequest>): Promise<void> {
  await db.collection(COLLECTION).doc(id).update({
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function getSignRequest(id: string): Promise<SignRequest | null> {
  const doc = await db.collection(COLLECTION).doc(id).get();
  if (doc.exists) {
    return { id: doc.id, ...doc.data() } as SignRequest;
  }
  return null;
}

export async function getSignRequestsBySource(sourceType: string, sourceId: string): Promise<SignRequest[]> {
  // Use simple query
  const q = db.collection(COLLECTION)
    .where("sourceType", "==", sourceType)
    .where("sourceId", "==", sourceId);
    
  const snap = await q.get();
  const items = snap.docs.map(d => ({ id: d.id, ...d.data() } as SignRequest));
  
  // Sort in memory
  return items.sort((a, b) => {
      const ta = a.createdAt?.toMillis ? a.createdAt.toMillis() : 0;
      const tb = b.createdAt?.toMillis ? b.createdAt.toMillis() : 0;
      return tb - ta;
  });
}

export function listenSignRequests(
  filters: { status?: string; userId?: string; role?: 'legal'|'manager' },
  onChange: (items: SignRequest[]) => void
) {
  // Fetch all and filter in memory to guarantee visibility if indexes are missing
  const q = db.collection(COLLECTION);

  return q.onSnapshot(snap => {
    const all = snap.docs.map(d => ({ id: d.id, ...d.data() } as SignRequest));
    
    // Default sort desc
    all.sort((a, b) => {
        const ta = a.createdAt?.toMillis ? a.createdAt.toMillis() : 0;
        const tb = b.createdAt?.toMillis ? b.createdAt.toMillis() : 0;
        return tb - ta;
    });

    let filtered = all;

    if (filters.status) {
        filtered = filtered.filter(i => i.status === filters.status);
    }
    
    if (filters.role === 'manager') {
       filtered = filtered.filter(i => i.status === 'PENDING_MANAGER');
    } else if (filters.role === 'legal') {
       filtered = filtered.filter(i => i.status === 'PENDING_LEGAL');
    } else if (filters.userId) {
       filtered = filtered.filter(i => i.createdByUserId === filters.userId);
    }

    onChange(filtered);
  });
}
